export { default } from './InformationPage';
